import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_ClientAcknowledgementsAdditionalConsents = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_ClientAcknowledgementsAdditionalConsents' className='file-pdf-document'>
            <div className='file-template'>

                <h4>CLIENT ACKNOWLEDGEMENTS AND ADDITIONAL CONSENTS
                </h4>
                <p className='w-750'>
                    <b>Confidentiality</b>
                    Privacy is a basic right of any individual who seeks psychotherapy services. Therefore, all information disclosed
                    within sessions and the written records pertaining to those sessions are confidential and may not be revealed to
                    anyone without your written permission, except where disclosure is required by law or as stated below. Amethyst
                    Consulting & Treatment Solutions, PLLC strives to follow privacy and confidentiality policies that meet North
                    Carolina Board of Psychology and federal guidelines, including guidelines contained within the Health Insurance
                    Portability and Accountability Act (HIPAA) when needed. Amethyst Consulting & Treatment Solutions, PLLC is
                    required by the Health Information Portability and Accountability Act (HIPAA) of 1996 to maintain the privacy of
                    your health information as stated in our Notice of Privacy Practices.
                </p>
                <p className='w-750'>
                    <b>Emergency Hospitalization</b>
                    I authorize Amethyst Consulting & Treatment Solutions, PLLC to contact the individual and/or physician/hospital I
                    have indicated in the event I become incapacitated due to emergency illness or accident while in treatment. This
                    emergency contact consent will be in lieu of any other authorizations, if any, I have granted, or not granted to the
                    below individual.
                </p>
                <p className='w-750'>
                    I hold harmless Amethyst Consulting & Treatment Solutions, PLLC against any liability caused by their taking of any
                    emergency procedures and/or contacts. I will assume the full responsibility of all incurred emergency treatment
                    expenses.
                </p>
                <p className='w-750'>
                    <b>Transportation</b>
                    In consideration for the opportunity to be transported by Amethyst Consulting & Treatment Solutions, PLLC, I
                    hereby release all participating groups and persons, including Amethyst Consulting & Treatment Solutions, PLLC
                    and persons connected with this program, including all employees, volunteers, and contractual persons affiliated
                    with Amethyst Consulting & Treatment Solutions, PLLC from any liability for any injury or damages whatsoever
                    arising from any participating program. This release is valid for one year from the date it is signed.
                </p>
                <p className='w-750'>
                    <b>Communications</b>
                    I acknowledge that I have read and fully understand the risks, limitations, conditions of use, and instructions for
                    use of the selected electronic communication services more fully described in the Appendix to this consent form. I
                    consent to the conditions and will follow the instructions outlined in the Appendix, as well as any other conditions
                    that Amethyst Consulting & Treatment Solutions may impose on communications with patients using the Services.
                    I acknowledge and understand that despite recommendations that encryption software be used as a security
                    mechanism for electronic communications, it is possible that communications with Amethyst Consulting &
                    Treatment Solutions or its staff using the Services may not be encrypted. Despite this, I agree to communicate with
                    Amethyst Consulting & Treatment Solutions or its staff using these services with a full understanding of the risk.
                </p>
                <p className='w-750'>
                    I acknowledge that either I or Amethyst Consulting & Treatment Solutions may, at any time, withdraw the option
                    of communicating electronically through the services upon providing written notice. Any questions I had have been
                    answered.
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbQuesAnswer" name="cbQuesAnswer" className='add-only' value="1" />
                            Email:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbQuesAnswer_1" name="cbQuesAnswer_1" className='add-only' value="2" />
                            Videoconferencing <span className='small'>(Google Meet, Microsoft Teams, Telehealth):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtQuesAnswer" name="txtQuesAnswer" />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtQuesAnswer_1" name="txtQuesAnswer_1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbQuesAnswer_2" name="cbQuesAnswer_2" className='add-only' value="3" />
                            Text Messages:
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbQuesAnswer_3" name="cbQuesAnswer_3" className='add-only' value="4" />
                            Website Portal:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtQuesAnswer_2" name="txtQuesAnswer_2" />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtQuesAnswer_3" name="txtQuesAnswer_3" />
                        </td>
                    </tr>
                </table>
                <h4>Program Participant Rights<br />
                    As a participant in programming of Amethyst Consulting & treatment Solutions, PLLC, you have the right to:
                </h4>
                <ul>
                    <li>Be fully informed about the course of your care and decisions that may affect your treatment.
                    </li>
                    <li>Revoke your consent for treatment at any time.
                    </li>
                    <li>Timely and accurate information to assist you in making sound decisions about your treatment.
                    </li>
                    <li>Be fully involved as an active participant in decisions pertaining to your treatment.
                    </li>
                    <li>Have an individual identified in writing that will direct and coordinate your treatment.
                    </li>
                    <li>Request a change in individual directing and coordinating our treatment, if you so desire.
                    </li>
                    <li>Receive services in an environment that is free of all forms of abuse, including, but not limited to, (a) financial abuse,
                        (b) physical abuse and punishment, (c) sexual abuse and exploitation, (d) psychological abuse including humiliation,
                        neglect, retaliation, threats and exploitation, and (e) all forms of seclusion.
                    </li>
                    <li>Have information about your treatment and your confidentiality protected to the greatest extent allowed by federal
                        and state confidentiality laws and regulations.
                    </li>
                    <li>File a grievance or complaint about the services you receive without fear of retaliation or reprisal of any sort.
                    </li>
                    <li>Have family members, friends or others involved in your treatment with your consent and approval.
                    </li>
                    <li>Receive services that comply with all applicable federal and state laws, rules and regulations
                    </li>
                    <li>File a grievance with an outside third party if you feel that the organization has not satisfactorily addressed any
                        concerns you have or does not adequately address any formal grievance you submit.
                    </li>
                    <li>To request a transfer to another program if you believe you are not receiving care that is meeting your needs and
                        preferences.
                    </li>
                    <li>You may also have additional rights afforded to you based on federal, state, and local regulations. Your service
                        coordinator will advise you of any additional rights that you may have.
                    </li>
                    <li>You have the right to treatment, including access to medical care and habilitation, regardless of age or
                        degree of mental illness, developmental disabilities, or substance abuse.
                    </li>
                </ul>
                <p className='w-750'><h3><b>Program Participant Responsibilities:</b></h3>
                    As a program participant of Amethyst Consulting & Treatment Solutions, PLLC, you have the responsibility to:
                </p>
                <ul>
                    <li>Refrain from all forms of physical violence or abuse toward other program participants, staff, or visitors
                    </li>
                    <li>Refrain from abusive language, disruptive behavior or overt sexual conduct
                    </li>
                    <li>Refrain from loitering outside the organization s facilitiesS
                    </li>
                    <li>Refrain from bringing any type of weapon into the organization s facilities or property
                    </li>
                    <li>Refrain from bringing any illicit (illegal) drug or alcohol onto the organization s property
                    </li>
                    <li>Refrain from using illicit drugs or alcohol while participating in services provided by the organization
                    </li>
                    <li>Use tobacco only in designated areas
                    </li>
                    <li>Attend all services required by the organization to meet agreed upon goals.
                    </li>
                    <li>Notify any outside treatment provider (Physician, case worker, counselor, etc.) of participation in services, should
                        your treatment impact, or compromise, the provision of those services
                    </li>
                    <li>Treat other program participants, staff, and visitors in a respectable manner.
                    </li>
                </ul>
                <p className='w-750'>
                    <span className='small'>I have read and understand all acknowledgements listed above. I also confirm that I have received the Amethyst Orientation packet.
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;
                        </td>
                        <td className='signature w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client/Responsible Party Signature:
                        </td>
                        <td className='small w-250'>Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;
                        </td>
                        <td className='signature w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Amethyst Representative Signature:
                        </td>
                        <td className='small w-250'>Date:
                        </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}  
